// React
import { useEffect } from "react"

// Components
import { Loading } from "components"
import { FormSection } from "./FormSection"

// Form
import { FormProvider, useForm } from "react-hook-form"

// Utils
import { useInvoiceDetail } from "../../ReturnRecord/utils"
import { type FormType, defaultValues, useDetail } from "../utils"

export function Detail(params: {
  refund_return_id: string
}): JSX.Element {
  // Hooks
  const invoice = useInvoiceDetail()
  const { data, isLoading, returnData } = useDetail(params.refund_return_id)

  // Form
  const methods = useForm<FormType>({
    defaultValues: defaultValues,
    disabled: true
  })

  useEffect(() => {
    if (data && returnData) {
      invoice.fetchData(returnData.datareturn.invoice_id)
      methods.reset({
        memo: data.memo,
        referensi: data.referensi,
        transaction_date: data.transaction_date,
        refund_return_detail: data.detail.map(item => {
          // Vars
          const selected = returnData.detailreturn.find(i => i.product_id === item.product_id)

          return {
            qty_return_item: parseFloat(item.qty_return_item),
            qty_unit: parseFloat(item.qty_unit),
            discount: selected?.discount_return ?? 0,
            price_refund: selected?.price_return ?? 0,
            product_barcode: selected?.product_barcode,
            product_id: selected?.product_id ?? 0,
            product_name: selected?.product_name ?? "",
            qty_back_returned: selected?.quantity_return ?? 0,
            quantity_unit_sell_convention: selected?.quantity_unit_sell_convention ?? 0,
            tax_id: selected?.tax_id ?? 0,
            tax_name: selected?.tax_name ?? "",
            tax_rate: selected?.tax_rate ?? 0,
            total: selected?.total_return ?? 0,
            total_tax_collect: selected?.total_tax_return ?? 0,
            unit_convention_name: selected?.unit_convention_name ?? "",
            unit_sell_measure_name: selected?.unit_sell_measure_name ?? ""
          }
        })
      })
    }

    // eslint-disable-next-line
  }, [data, returnData])

  return (
    <div className="container my-5 flex flex-col gap-3">
      {isLoading || !data || !returnData ? (
        <Loading
          errorText="No data available"
          loading={isLoading}
        />
      ) : (
        <FormProvider {...methods}>
          <FormSection
            approvalView={true}
            approve_by={data.approve_by}
            approve_status={data.approve_status}
            trx_code={data.trx_code}
            invoice={{
              sales_order_id: invoice.data?.sales_order_id,
              trx_code: invoice.data?.trx_code
            }}
            return={{
              address: returnData.datareturn.address,
              customer_id: returnData.datareturn.customer_id,
              customer_name: returnData.datareturn.customer_name,
              detailreturn: returnData.detailreturn,
              invoice_id: returnData.datareturn.invoice_id,
              location_id: returnData.datareturn.location_id,
              location_name: returnData.datareturn.location_name,
              return_status: returnData.datareturn.return_status,
              transaction_date: returnData.datareturn.transaction_date,
              trx_code: returnData.datareturn.trx_code
            }}
          />
        </FormProvider>
      )}
    </div>
  )
}